export default __webpack_public_path__ + "989955bd2ec9da548f49762b0fb2dac2.svg";